export enum ShapeName {
  Circle = "Circle",
  Square = "Square",
  Hexagon = "Hexagon",
  ExclamationDiamond = "ExclamationDiamond",
}
